import { render, staticRenderFns } from "./TwoSn.vue?vue&type=template&id=1241811d&scoped=true&"
import script from "./TwoSn.vue?vue&type=script&lang=js&"
export * from "./TwoSn.vue?vue&type=script&lang=js&"
import style0 from "./TwoSn.vue?vue&type=style&index=0&id=1241811d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241811d",
  null
  
)

export default component.exports